export const getAuthToken = () => {
  return localStorage.getItem("hr_token");
};

export const setAuthToken = (token) => {
  return localStorage.setItem("hr_token", token);
};

export const removeAuthToken = () => {
  localStorage.removeItem("hr_token");
  localStorage.clear();
  localStorage.removeItem("prevPath");
  window.location.reload(false);
};
